export default __webpack_public_path__ + "static/media/role.11d45b76.wav";